
import wx from 'weixin-js-sdk'
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import CheckIcon from 'vux/src/components/check-icon/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Radio from 'vux/src/components/radio/index.vue'


export default {
name: 'deviceEdit',
components: {
wx,PopupPicker,CheckIcon,XTextarea,Group,Radio
},
data() {
return {
types:[],
type:1,
locations:[
{
key:0,
value:'店外（开锁成功播报）'
},
{
key:1,
value:'店内（进店后播报）'
},
],
location:1,
formData:{
id:0,
code:'',
title:'',
content:'',
type:1,
location:1,
},
}
},
created() {
this.formData.id = Number(this.$route.params.id);
if(this.formData.id > 0){
this.getDeviceInfo();
}
this.config();
this.deviceType();
},
computed:{

},
methods: {
deviceType(){
this.$api.deviceType({}).then((res)=>{
if(res){
this.types = res.data.device_type;
this.types.forEach((item)=>{
item.icon = item.img;
item.key = item.type;
item.value = item.title;
})
console.log(this.types);
}
})
},
changeType(val){
this.formData.type = val;
},
changeLocation(val){
this.formData.location = val;
},
getDeviceInfo(){
this.$api.getDeviceInfo({id:this.formData.id}).then((res)=>{
if(res){
this.formData = res.data;
this.type = res.data.type;
this.location = res.data.location;
console.log('formData',this.formData);
}
})
},
submit() {
if(!this.formData.code){
this.$func.showToast('请输入设备序列号');
return false;
}
if(!this.formData.title){
this.$func.showToast('请输入设备名称');
return false;
}
this.$api.bindDevice(this.formData).then((res)=>{
if(res.code == 0){
this.$func.showToast('提交成功');
setTimeout(()=>{
this.$router.go(-1);
},300)
}
});
},
scanQRCode(){
let that = this;
wx.ready(()=> {
wx.scanQRCode({
needResult: 1,
scanType: ['qrCode','barCode'],
success: function (res) {
setTimeout(()=>{
let result = res.resultStr;
if(result.indexOf(",") != -1){
result = result.split(',')[1];
}else{
if(result.indexOf('http') != -1 || result.indexOf('/') != -1){
const parts = result.split('/').filter(item => item !== "");
result = parts[parts.length - 1] || result;
}
}
that.formData.code = result;
},300);
}
})
});
wx.error((res)=> {
console.log(res)

})
},
config(){
let url = (window.location.href).split('#');
if(url[0].indexOf('?') != '-1'){
url = url[0].split('?');
}
this.$api.wxSign({url:url[0]}).then((res)=>{
if(res){
wx.config({
debug: false,
appId: res.data.appId,
timestamp: res.data.timestamp,
nonceStr: res.data.nonceStr,
signature:res.data.signature,
jsApiList: [
"scanQRCode"
]
});
}
})
},
}
}



// WEBPACK FOOTER //
// ./src/pages/deviceEdit.vue